import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'antd'
// import { useTranslation } from 'react-i18next'
import { FaBattleNet,
         FaFacebookSquare,
         FaFreeCodeCamp,
         FaGithubSquare,
         FaGitlab,
         FaInstagramSquare,
         FaLinkedin,
         FaPlaystation,
         FaSkype,
         FaSteamSquare,
         FaTwitch,
         FaGoogle
        } from "react-icons/fa";

const Social = () => {

    // const {t} = useTranslation()

    const socials = [
        {
            id: 1,
            title: 'Overwatch',
            icon: <FaBattleNet title={'Overwatch'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://playoverwatch.com/en-us/career/pc/lpgoulart-1153/',
                exist: true
            }
        },
        {
            id: 2,
            title: 'Facebook',
            icon: <FaFacebookSquare title={'Facebook'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://www.facebook.com/leogoulartmelo/',
                exist: true
            }
        },
        {
            id: 3,
            title: 'FreeCodeCamp',
            icon: <FaFreeCodeCamp title={'FreeCodeCamp'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://www.freecodecamp.org/lpgoulart',
                exist: true
            }
        },
        {
            id: 4,
            title: 'Github',
            icon: <FaGithubSquare title={'Github'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://github.com/lpgoulart',
                exist: true
            }
        },
        {
            id: 5,
            title: 'Gitlab',
            icon: <FaGitlab title={'Gitlab'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://projetos.imd.ufrn.br/goulart',
                exist: true
            }
        },
        {
            id: 6,
            title: 'Instagram',
            icon: <FaInstagramSquare title={'Instagram'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://www.instagram.com/_lpgoulart/',
                exist: true
            }
        },
        {
            id: 7,
            title: 'Linkedin',
            icon: <FaLinkedin title={'Linkedin'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://www.linkedin.com/in/lpgoulart',
                exist: true
            }
        },
        {
            id: 8,
            title: 'Playstation',
            icon: <FaPlaystation title={'PSN'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: '',
                exist: false
            }
        },
        {
            id: 9,
            title: 'Skype',
            icon: <FaSkype title={'Skype'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: '',
                exist: false
            }
        },
        {
            id: 10,
            title: 'Steam',
            icon: <FaSteamSquare title={'Steam'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://steamcommunity.com/id/lpgoulart/',
                exist: true
            }
        },
        {
            id: 11,
            title: 'Twitch',
            icon: <FaTwitch title={'Twitch'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: 'https://www.twitch.tv/lpgoulart',
                exist: true
            }
        },
        {
            id: 12,
            title: 'Google',
            icon: <FaGoogle title={'Gmail'} color={'#f0f2f5'} size={'4rem'} />,
            link: {
                path: '',
                exist: false
            }
        },
    ]

    return (
        <>
            <Container>
                <Row justify='center'>
                    <Col>
                        <h2 style={{textAlign: 'center'}}>Social</h2>
                    </Col>
                </Row>

                <Row justify='center' align={'center'} style={{width: '100%', padding: '30px 0'}}>
                    {socials.map(item=> {
                        return (
                            <>
                                {item.link.exist && 
                                <Col xs={12} sm={12} md={6} lg={2} xl={2} style={{padding: '20px 0'}}>
                                    <a href={item.link.path} rel="noopener noreferrer" target='_blank'>{item.icon}</a>
                                    <H2>{item.title}</H2>
                                </Col>}

                                {!item.link.exist && 
                                <Col xs={12} sm={12} md={6} lg={2} xl={2} style={{padding: '20px 0'}}>
                                    {item.icon}
                                    <H2>{item.title}</H2>
                                </Col>}
                            </>
                        )
                    })}
                </Row>

            </Container>
        </>
    )
}

export default Social;

const Container = styled.div`
    background-color: #010008;
    padding: 40px 0;
    text-align: center;
    & *{
        color: #f0f2f5;
        font-family: 'Share Tech Mono', monospace;
    }
    & h2 {
        font-size: 30px;
    }
`

const H2 = styled.h2`
    font-size: 14px!important
`